import { Steps } from 'antd';
import { DefaultOptionType } from 'antd/es/select';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { IStatus, PROCESS_TRAVEL_NAME, STATUS_NAME } from '@/pages/project-management/project-list-v2/models';

import AppTooltip from '@/components/app-tooltip/AppTooltip';
import { CircleExclamationTriangleIcon } from '@components/icon-svg';

import { FORMAT_DATE_JP } from '@/utils/constants/AppConstants';

import AirplaneTakeoff from '@/assets/icons/AirplaneTakeoff.svg';
import DisableRow from '@/assets/icons/DisableRow.svg';
import DisabledStep from '@/assets/icons/DisabledStep.svg';
import DotStep from '@/assets/icons/DotStep.svg';
import FinishStep from '@/assets/icons/FinishStep.svg';
import ProcessStep from '@/assets/icons/ProcessStep.svg';

import './Steps.scss';

const { Step } = Steps;

interface IStepsProcessProps {
  stepData?: DefaultOptionType[] | null;
  listStatus: IStatus[];
  disabled?: boolean | null;
  active?: boolean | null;
}

export const StepsProcess = ({ stepData, listStatus, disabled, active }: IStepsProcessProps) => {
  const { t } = useTranslation();
  const showCancel = !active;

  const isTravelStep = (item: DefaultOptionType) => (item.processName ?? item.name) === PROCESS_TRAVEL_NAME;
  const renderCustomIcon = (item: DefaultOptionType, statusName?: STATUS_NAME) => {
    const mappingIcon = {
      [STATUS_NAME.TODO]: <DisabledStep />,
      [STATUS_NAME.DELAYED]: <CircleExclamationTriangleIcon className='text-negative' />,
      [STATUS_NAME.IN_PROGRESS]: <ProcessStep />,
      [STATUS_NAME.COMPLETED]: <FinishStep />
    };
    const icon = isTravelStep(item) ? <AirplaneTakeoff /> : statusName && mappingIcon[statusName] ? mappingIcon[statusName] : <DotStep />;
    const title = statusName && mappingIcon[statusName] ? statusName : t('project_management:status:not_execute');
    return <AppTooltip title={title}>{icon}</AppTooltip>;
  };

  return (
    <div className={`form-step-wrapper min-h-[76px] ${disabled ? 'disabled-process' : ''}`}>
      <div className='mot-pick relative'>
        {showCancel && <DisableRow className='absolute step-disable-icon left-[40%]' width={146} height={66} />}
        {stepData && stepData?.length !== 0 ? (
          <Steps className={showCancel ? 'opacity-40' : ''} labelPlacement='vertical'>
            {stepData.map((item: DefaultOptionType, index: number) => {
              const matchedStatus = listStatus.find((status) => status.id === item.statusId);
              return (
                <Step
                  key={index + 1}
                  title={item?.name ?? item?.processName}
                  className={`
                    ${!matchedStatus && !isTravelStep(item) ? 'small-dot' : ''}
                    ${!matchedStatus || matchedStatus?.name === STATUS_NAME.TODO ? 'line-dotted' : 'line-dotted-active'}
                    `}
                  subTitle={
                    matchedStatus?.name === STATUS_NAME.COMPLETED && item?.completedDate
                      ? dayjs(item.completedDate).format(FORMAT_DATE_JP)
                      : undefined
                  }
                  icon={renderCustomIcon(item, matchedStatus?.name)}
                />
              );
            })}
          </Steps>
        ) : (
          <div className={`h-[76px] flex items-center justify-center ${showCancel ? 'opacity-40' : ''}`}>{t('project:status:not_started')}</div>
        )}
      </div>
    </div>
  );
};
